import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarGold = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.49297 19.5L6.11797 12.475L0.667969 7.75L7.86797 7.125L10.668 0.5L13.468 7.125L20.668 7.75L15.218 12.475L16.843 19.5L10.668 15.775L4.49297 19.5Z",
		fill: "#EED600"
	})]
});
const ForwardRef = forwardRef(SvgStarGold);
export { ForwardRef as ReactComponent };
